import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { installDomTranslateGuard } from "./dom-translate-guard";

// Çeviri eklentisi kaynaklı insertBefore/removeChild çökmelerini engelle.
// React render edilmeden ÖNCE kurulmalı.
installDomTranslateGuard();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
